// 로컬 에이전트(데몬)로 보내는 «화면 작업 살아 있음» 박동 판정 — 진척(onProgress) 없이 오래 가면 박동을 멈춘다.
// 10-20 윈 outbox 3255·2853: 진척과 무관하게 30초마다 running 을 보내 데몬 10분 시계가 계속 늘어 job 이 영원히 running.
// 30분 = workflowService 작업 한도(이미지 15분 · 견적서 30분)보다 길게 — 보통은 작업 한도가 먼저 오류로 끝낸다.
export const CLI_PAGE_STALL_MS = 30 * 60 * 1000

// 진척 한 번 뒤 기다려 줄 길이 — 그 진척이 알린 일감 한도(workMs · 예: 상품 하나 작업 한도 합)가 30분보다 길면 그만큼.
// 대표이미지는 옵션마다 직렬이라 48옵션이면 96분 — 작업개시는 상품마다 한 번만 진척을 내므로 30분 고정이면 큰 상품이 끊긴다.
export function stallLimitMs(workMs) {
  return Math.max(CLI_PAGE_STALL_MS, Number(workMs) || 0)
}

export function shouldBeat(lastProgressAt, now, stallMs = CLI_PAGE_STALL_MS) {
  if (typeof lastProgressAt !== 'number') return false
  return now - lastProgressAt <= stallMs
}
